import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import classNames from "classnames"
import { mantineIssueSelectCellConnection } from "app/static/frontend/sheets/selectors/column-selectors"
import { patchColumnData, toggleSelectOpen } from "app/static/frontend/sheets/sheet-action-creators"

import { IssueManagementSelect } from "app/static/frontend/selects/containers/PieSelect"
import { CellWrapper } from "app/static/frontend/sheets/components/cells/MantineCells/CellWrapper"

export const UnconnectedIssueSelectCell = ({
    children,
    sheetId,
    rowId,
    columnId,
    editing,
    isPublicSheet,
    savedSearchAddedIds,
    savedSearchDeletedIds,
    savedSearchFilters,
    displayValues,
    menuShouldScrollIntoView,
    selectIds,
    row,
    ...props
}) => {
    return (
        <CellWrapper className={classNames({ "issue-select-cell": !isPublicSheet })} {...props} truncate={!editing}>
            {editing && !isPublicSheet ? (
                <IssueManagementSelect
                    className="new-select-dropdown-cell"
                    shouldRenderNewSelect
                    // eslint-disable-next-line jsx-a11y/no-autofocus
                    autoFocus
                    id={`${sheetId}:${rowId}:${columnId}`}
                    // only the issues from this column's source_saved_search should be
                    // available as options in this select; add filters based on the saved search
                    permanentFilter={{
                        // if there are no filters, the added ids constitute all the ids we want
                        // use id__in to filter by these ids
                        ...(!savedSearchFilters || !savedSearchFilters.length ? { id__in: savedSearchAddedIds } : {}),
                        // if there are other filters or deleted ids, added ids represent additional
                        // ids we want after filtering / removing ids; send them as added_ids
                        ...((savedSearchFilters && savedSearchFilters.length) ||
                        (savedSearchDeletedIds && savedSearchDeletedIds.length)
                            ? { added_ids: savedSearchAddedIds }
                            : {}),
                        // always send the deleted_ids as deleted_ids
                        deleted_ids: savedSearchDeletedIds,
                        // change the savedsearch filters into an object of (filter: value) pairs
                        ...(savedSearchFilters && savedSearchFilters.length
                            ? // @ts-expect-error
                              Object.assign(...savedSearchFilters.map((item) => item))
                            : {}),
                    }}
                    onChange={(selections) =>
                        props.patchColumnData({
                            id: sheetId,
                            columnId,
                            rowId,
                            newValue: selections.map((obj) => ({ name: obj.name, id: obj.id })),
                            safe: false,
                            row,
                        })
                    }
                    value={selectIds}
                    clearable
                    autoload={editing}
                    searchify={false}
                    onOpen={() => {
                        props.toggleSelectOpen(sheetId, true)
                    }}
                    onClose={() => {
                        props.toggleSelectOpen(sheetId, false)
                    }}
                    menuShouldScrollIntoView={menuShouldScrollIntoView}
                    multi
                />
            ) : (
                displayValues
            )}
        </CellWrapper>
    )
}

UnconnectedIssueSelectCell.propTypes = {
    children: PropTypes.object.isRequired,
    patchColumnData: PropTypes.func.isRequired,
    rowId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    columnId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    toggleSelectOpen: PropTypes.func.isRequired,
    sheetId: PropTypes.string.isRequired,
    isPublicSheet: PropTypes.bool,
    editing: PropTypes.bool.isRequired,
    menuShouldScrollIntoView: PropTypes.bool,
}

UnconnectedIssueSelectCell.defaultProps = {
    isPublicSheet: false,
    menuShouldScrollIntoView: false,
}

export const IssueSelectCell = connect((state, props) => mantineIssueSelectCellConnection(state, props), {
    patchColumnData,
    toggleSelectOpen,
})(UnconnectedIssueSelectCell)
